import { createAsyncThunk } from "@reduxjs/toolkit";
import { setExplainWithCurrentBillingData } from "@/store/explain-with-ai/explainWithAiSlice";
import { RootState } from "@/store/store";
import { getBillingExplorerSummaryFixedCashKeySelector } from "@/store/explain-with-ai/selectors/data/billing-explorer/getBillingExplorerSummaryFixedCashKeySelector";
import { resourceExplorerPayloadDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resource-explorer-widget/resourceExplorerPayloadDataSelector";
import { addFilterTreePathToResourceExplorerPayload } from "@/store/resource-explorer/utils/helpers/addFilterTreePathToResourceExplorerPayload";

export const setBillingExplorerExplainWithAIDataThunk = createAsyncThunk(
  "resourceExplorer/setBillingExplorerExplainWithAIData",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;

    const newKey = getBillingExplorerSummaryFixedCashKeySelector(state) ?? "";
    const resourceExplorerDataGettingPayload =
      resourceExplorerPayloadDataSelector(state);
    const payload = addFilterTreePathToResourceExplorerPayload(
      resourceExplorerDataGettingPayload,
    );

    dispatch(
      setExplainWithCurrentBillingData({
        key: newKey,
        payload,
      }),
    );
  },
);
